import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import chatIcon from "../../images/newDesign/chatIcon.svg";
import Checkbox from "../../common/simple/Checkbox";
import {StyledAutoCampaignCard} from "./AutoCampaign.styled";

export function AutoCampaignCard({apt, inMonitoring, updateSelectedItems, onAptNotesOpen, selectAll, popUpExited}) {
    const ltr = useSelector(state => state.common.ltrEnabled);

    const [isChecked, setIsChecked] = useState(false);

    useEffect(() => {
        if (isChecked) {
            updateSelectedItems(true, apt.apartmentNumber);
        } else {
            updateSelectedItems(false, apt.apartmentNumber);
        }
    }, [isChecked]);

    useEffect(() => {
        setIsChecked(selectAll);
    }, [selectAll]);

    useEffect(() => {
        if (popUpExited){
            setIsChecked(false);
        }
    }, [popUpExited]);

    useEffect(() => {
        setIsChecked(false);
    }, [inMonitoring]);
    const handleAptNotes = () => {
        onAptNotesOpen(apt.apartmentNumber);
    }
    const getCardContent = () => {
        return <>
            <div>{apt.apartmentNumber}</div>
            {getAptContent(apt.name[0], apt.name[1])}
            {getAptContent(apt.phone[0], apt.phone[1])}
            {getAptContent(apt.notificationsEmail[0], apt.notificationsEmail[1])}
            {getAptContent(apt.paymentDate[0], apt.paymentDate[1])}
            {inMonitoring && getInCampaignContent(apt)}
            <div className="apt-notes">
                <img src={chatIcon} alt='chat' onClick={handleAptNotes}/>
            </div>
        </>
    }

    const getInCampaignContent = (apt) => {
        return <>
            {getAptContent(apt.messageType[0], apt.messageType[1])}
            {getAptContent(apt.nextFace[0], apt.nextFace[1])}
        </>
    }
    const getAptContent = (owner, tenant) => {
        return <>
            <div className="apt-content">
                <div>{owner}</div>
                <div>{tenant}</div>
            </div>
        </>
    }

    return (
        <StyledAutoCampaignCard inMonitoring={inMonitoring} ltr={ltr} className="bllink-text">
            <Checkbox
                size={19}
                checked={isChecked}
                onChange={() => setIsChecked(!isChecked)}
                borderWidth={1}
            />
            <div className="card">
                {getCardContent()}
            </div>
        </StyledAutoCampaignCard>
    )
}